import loadable from '../../utilities/loadable'

export const EntryPoint = loadable(() => import('./EntryPoint'))
